import Link from 'next/link';

import styled from 'styled-components';

export const ButtonLink = styled(Link)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  background: ${({ theme }) => theme.tokens.colors.neutral['200']};
  color: ${({ theme }) => theme.tokens.colors.secondary['100']};
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.25rem;

  &::after {
    content: '';
    display: block;
    width: 0.5rem;
    height: 0.5rem;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' fill='none'%3E%3Cpath stroke='%230070F0' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M8.658 8.28V1.671H2.051'/%3E%3Cpath stroke='%230070F0' stroke-linecap='round' stroke-width='1.5' d='m1.344 8.985 7.071-7.07'/%3E%3C/svg%3E");
    pointer-events: none;
  }
`;
